/**
 * MIXUP BR — Utilitários de Exportação
 * → C:\projetos\mixup-lojista\src\utils\exportUtils.js
 */

// ── Exportar para Excel (CSV com BOM para acentos) ──
export function exportExcel(headers, rows, filename = "relatorio") {
  const BOM = "\uFEFF";
  const sep = ";";
  const csvH = headers.join(sep);
  const csvR = rows.map(r => r.map(c => `"${String(c ?? "").replace(/"/g, '""')}"`).join(sep)).join("\n");
  const csv = BOM + csvH + "\n" + csvR;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

// ── Exportar para PDF (abre janela de impressão estilizada) ──
export function exportPDF(titulo, conteudoHTML, filename = "relatorio") {
  const win = window.open("", "_blank");
  if (!win) { alert("Permita pop-ups para exportar PDF"); return; }
  win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>${titulo}</title>
    <style>
      *{margin:0;padding:0;box-sizing:border-box}
      body{font-family:'Segoe UI',system-ui,sans-serif;padding:24px;color:#1a1a1a;font-size:12px}
      h1{font-size:20px;margin-bottom:4px}
      h2{font-size:14px;margin:16px 0 8px;color:#444;border-bottom:1px solid #ddd;padding-bottom:4px}
      .subtitle{font-size:11px;color:#888;margin-bottom:16px}
      .logo{font-weight:800;font-size:22px;margin-bottom:2px}
      .logo span:first-child{color:#E53935}
      .logo span:last-child{color:#43A047}
      table{width:100%;border-collapse:collapse;margin:8px 0 16px}
      th{background:#f5f5f5;text-align:left;padding:8px 10px;font-size:11px;font-weight:700;border-bottom:2px solid #ddd}
      td{padding:7px 10px;border-bottom:1px solid #eee;font-size:11px}
      tr:nth-child(even){background:#fafafa}
      .kpi-row{display:flex;gap:12px;margin:12px 0}
      .kpi{flex:1;background:#f8f8f8;border:1px solid #e0e0e0;border-radius:8px;padding:10px;text-align:center}
      .kpi-val{font-size:18px;font-weight:800}
      .kpi-label{font-size:9px;color:#888;margin-top:2px;text-transform:uppercase}
      .badge{display:inline-block;padding:2px 8px;border-radius:4px;font-size:10px;font-weight:700}
      .green{color:#22C55E}.red{color:#E53935}.blue{color:#3B82F6}.orange{color:#F97316}
      .footer{margin-top:24px;padding-top:8px;border-top:1px solid #ddd;font-size:9px;color:#aaa;text-align:center}
      @media print{body{padding:12px}}
    </style>
  </head><body>
    <div class="logo"><span>Mix</span><span>Up</span></div>
    <h1>${titulo}</h1>
    <div class="subtitle">Gerado em ${new Date().toLocaleString("pt-BR")} · MixUp BR</div>
    ${conteudoHTML}
    <div class="footer">MixUp BR — Relatório gerado automaticamente · mixupbr.com.br</div>
  </body></html>`);
  win.document.close();
  setTimeout(() => { win.print(); }, 400);
}

// ── Helpers de formatação ──
export function fmtMoeda(v) {
  return "R$ " + Number(v || 0).toFixed(2).replace(".", ",");
}

export function fmtData(d) {
  if (!d) return "—";
  return new Date(d).toLocaleString("pt-BR", { day:"2-digit", month:"2-digit", year:"2-digit", hour:"2-digit", minute:"2-digit" });
}

export function fmtDataCurta(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("pt-BR");
}

// ── Classificar turno ──
export function getTurno(criadoEm) {
  if (!criadoEm) return "—";
  const h = new Date(criadoEm).getHours();
  if (h >= 6 && h < 12) return "Manha";
  if (h >= 12 && h < 18) return "Tarde";
  return "Noite";
}

// ── Filtro por período ──
export function filtrarPorPeriodo(orders, periodo, dataInicio, dataFim) {
  const now = new Date();
  const todayStr = now.toISOString().slice(0, 10);
  const monthStr = now.toISOString().slice(0, 7);
  const yearStr = String(now.getFullYear());

  // Semana atual
  const getWeekStart = () => {
    const d = new Date(now);
    const day = d.getDay();
    d.setDate(d.getDate() - (day === 0 ? 6 : day - 1));
    return d.toISOString().slice(0, 10);
  };

  switch (periodo) {
    case "hoje": return orders.filter(o => o.criado_em?.startsWith(todayStr));
    case "ontem": {
      const y = new Date(now); y.setDate(y.getDate() - 1);
      const yStr = y.toISOString().slice(0, 10);
      return orders.filter(o => o.criado_em?.startsWith(yStr));
    }
    case "semana": {
      const ws = getWeekStart();
      return orders.filter(o => o.criado_em && o.criado_em.slice(0, 10) >= ws);
    }
    case "mes": return orders.filter(o => o.criado_em?.startsWith(monthStr));
    case "ano": return orders.filter(o => o.criado_em?.startsWith(yearStr));
    case "custom":
      if (dataInicio && dataFim) {
        return orders.filter(o => o.criado_em && o.criado_em.slice(0, 10) >= dataInicio && o.criado_em.slice(0, 10) <= dataFim);
      }
      return orders;
    default: return orders;
  }
}
